import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExploreIdeas = () => {
    const [exploreIdeas, setexploreIdeas] = useState([]);
    const [formData, setFormData] = useState({
        tab: "",
        mediaUrl: null,
    });
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedVideoId, setSelectedVideoId] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleDelete = (_id) => {
        setSelectedVideoId(_id);
        setShowConfirm(true);
    };

    // Handle delete
    const confirmDelete = async (id) => {
        try {
            await axios.delete(`${backend_url}/api/exploreideas/${id}`);
            setShowConfirm(false);
            toast.success("exploreIdeas deleted Successfully")
            fetchExploreIdeas();
        } catch (error) {
            toast.error("Error deleting exploreIdeas:", error);
        }
    };


    // Fetch all FAQ
    useEffect(() => {
        fetchExploreIdeas();
    }, []);

    const fetchExploreIdeas = async () => {
        try {
            const response = await axios.get(`${backend_url}/api/exploreideas`);
            setexploreIdeas(response.data);
        } catch (error) {
            toast.error("Error fetching explore ideas:", error);
        }
    };

    // Handle form input change
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "mediaUrl") {
            if (!files.length) return;

            const file = files[0];
            const isImage = file.type.startsWith("image");
            const maxSize = isImage ? 1 * 1024 * 1024 : 20 * 1024 * 1024;

            if (file.size > maxSize) {
                toast.error(`File size exceeds the limit of ${isImage ? "1MB" : "20MB"}`);
                return;
            }

            setFormData({ ...formData, mediaUrl: file });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };


    // Add or update variety
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.mediaUrl) {
            toast.error("Please upload an image or video.");
            return;
        }

        const data = new FormData();
        data.append("tab", formData.tab);
        data.append("mediaUrl", formData.mediaUrl);

        try {
            await axios.post(`${backend_url}/api/exploreideas`, data);
            toast.success("Our Idea Added Successfully")
            fetchExploreIdeas();
            closeModal();
        } catch (error) {
            toast.error("Error saving for Faq:", error);
        }
    };

    // Close modal and reset form
    const closeModal = () => {
        setShowModal(false);
        setFormData({ mediaUrl: null, question: "", answer: "" });
    };

    return (
        <>
            <div className="variety-admin">
                <div className="headerSections">
                    <div className="head-title">Explore Our Ideas</div>
                    <button className="add-btn" onClick={() => setShowModal(true)}>
                        + Add Our Idea
                    </button>
                </div>

                {/* Popup Modal */}
                {showModal && (
                    <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal" onClick={(e) => e.stopPropagation()}>
                            <h2>Add Our Idea</h2>
                            <form onSubmit={handleSubmit} className="variety-form">
                            <div className="form-group">
                                    <label htmlFor="tab">Choose the Section</label>
                                    <select
                                        id="tab"
                                        name="tab"
                                        value={formData.tab}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Section</option>
                                        <option value="Images">Images</option>
                                        <option value="Videos">Videos</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="mediaUrl">Upload Image/Video</label>
                                    <input
                                        type="file"
                                        id="mediaUrl"
                                        name="mediaUrl"
                                        onChange={handleChange}
                                        accept={formData.tab === "Images" ? "image/*" : "video/*"}
                                    />
                                </div>

                                <div className="form-buttons">
                                    <button type="submit" className="submit-btn">
                                        Add                                    </button>
                                    <button type="button" onClick={closeModal} className="cancel-btn">
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* List Table */}
                <table className="variety-table">
                    <thead>
                        <tr>
                            <th>Choosen Section</th>
                            <th>Media</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {exploreIdeas.map((explore) => (
                            <tr key={explore._id}>
                                <td>{explore.tab}</td>
                                <td>
                                {explore.tab === "Images" ? (
                                        <img src={`${explore.mediaUrl}`} alt="Media" style={{ width: "100px" }} />
                                    ) : (
                                        <video width="100" autoPlay muted loop>
                                            <source src={`${explore.mediaUrl}`} type="video/mp4" />
                                        </video>
                                    )}                                </td>
                                <td>
                                    <button onClick={() => handleDelete(explore._id)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>


            {/* Confirmation Popup */}
            {
                showConfirm && (
                    <div className="confirm-popup">
                        <div className="confirm-content">
                            <p>Are you sure you want to delete this ideas?</p>
                            <div className="popup-actions">
                                <button onClick={() => confirmDelete(selectedVideoId)} className="confirm-btn">
                                    Confirm
                                </button>
                                <button onClick={() => setShowConfirm(false)} className="cancel-btn">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
            <ToastContainer />
        </>
    );
};

export default ExploreIdeas;
